import Vue from "vue";
import "element-ui/lib/theme-chalk/index.css";

import {
  Table,
  Upload,
  Input,
  FormItem,
  DatePicker,
  Select,
  Checkbox,
  Dialog,
  Form,
  Empty,
  TableColumn,
  Row,
  Col,
  ButtonGroup,
  Button,
  MessageBox,
  Message,
  Carousel,
  CarouselItem
} from "element-ui";
[
  Table,
  Upload,
  Input,
  FormItem,
  DatePicker,
  Select,
  Checkbox,
  Dialog,
  Form,
  Empty,
  TableColumn,
  Row,
  Col,
  ButtonGroup,
  Button,
  Carousel,
  CarouselItem
].forEach(component => Vue.use(component))

//注册全局方法
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$prompt = MessageBox.prompt;
Message.duration = 3000
Vue.prototype.$message = Message;


// WEBPACK FOOTER //
// ./src/plugins/elemenet/index.js